var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 107,
    viewBox: "20 0 166 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_19_3710)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_19_3710",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 16C20 7.16345 27.1634 0 36 0H170C178.837 0 186 7.16344 186 16V91C186 99.8366 178.837 107 170 107H36C27.1634 107 20 99.8366 20 91V16Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 16C20 7.16345 27.1634 0 36 0H170C178.837 0 186 7.16344 186 16V91C186 99.8366 178.837 107 170 107H36C27.1634 107 20 99.8366 20 91V16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 0V0.8H170V0V-0.8H36V0ZM186 16H185.2V91H186H186.8V16H186ZM170 107V106.2H36V107V107.8H170V107ZM20 91H20.8V16H20H19.2V91H20ZM36 107V106.2C27.6053 106.2 20.8 99.3947 20.8 91H20H19.2C19.2 100.278 26.7216 107.8 36 107.8V107ZM186 91H185.2C185.2 99.3947 178.395 106.2 170 106.2V107V107.8C179.278 107.8 186.8 100.278 186.8 91H186ZM170 0V0.8C178.395 0.8 185.2 7.60527 185.2 16H186H186.8C186.8 6.72162 179.278 -0.8 170 -0.8V0ZM36 0V-0.8C26.7216 -0.8 19.2 6.72162 19.2 16H20H20.8C20.8 7.60527 27.6053 0.8 36 0.8V0Z",
    fill: "#E5E7EB",
    mask: "url(#path-1-inside-1_19_3710)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_3710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8 41.8403H173.8",
    stroke: "#E5E7EB",
    strokeWidth: 0.865455
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8 53.4801H173.8",
    stroke: "#E5E7EB",
    strokeWidth: 0.865455
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8 65.1199H173.8",
    stroke: "#E5E7EB",
    strokeWidth: 0.865455
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8 76.7597H173.8",
    stroke: "#E5E7EB",
    strokeWidth: 0.865455
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7092 30.2004V88.3995",
    stroke: "#E5E7EB",
    strokeWidth: 0.865455
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6182 30.2004V88.3995",
    stroke: "#E5E7EB",
    strokeWidth: 0.865455
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.527 30.2004V88.3995",
    stroke: "#E5E7EB",
    strokeWidth: 0.865455
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.437 30.2004V88.3995",
    stroke: "#E5E7EB",
    strokeWidth: 0.865455
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.345 30.2004V88.3995",
    stroke: "#E5E7EB",
    strokeWidth: 0.865455
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0273 79.6697C51.3304 77.7297 59.6334 75.7898 67.9364 73.8498C76.2395 71.9098 82.4408 62.449 90.7438 58.5691C99.0468 56.6291 109.296 60.397 120.713 61.768C128.799 61.768 141.903 59.2501 150.206 55.3701C158.509 52.6542 159.27 39.1243 167.573 36.0204V88.3996H43.0273V79.6697Z",
    fill: "url(#paint0_linear_19_3710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0273 79.6697C51.3304 77.7297 59.6334 75.7898 67.9364 73.8498C76.2395 71.9098 81.1184 62.0659 89.7924 59.026C97.82 56.2128 111.004 61.768 120.237 61.768C128.799 61.768 137.838 59.8629 148.779 56.2841C157.082 53.5682 159.27 39.1243 167.573 36.0204",
    stroke: "url(#paint1_linear_19_3710)",
    strokeWidth: 2.59636,
    strokeLinecap: "round",
    strokeDasharray: "0.87 0.87"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_19_3710",
    x: 0,
    y: 0,
    width: 206,
    height: 147,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_19_3710"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_3710"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_19_3710"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_19_3710",
    result: "effect2_dropShadow_19_3710"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_19_3710",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_3710",
    x1: 43.0273,
    y1: 36.0204,
    x2: 43.0273,
    y2: 88.3996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B8A6",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#10B981",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B981",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19_3710",
    x1: 43.0273,
    y1: 36.0204,
    x2: 167.573,
    y2: 36.0204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D9488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B981"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_3710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137,
    height: 85,
    fill: "white",
    transform: "translate(36.8 16.8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph1);
export default __webpack_public_path__ + "static/media/graph1.f03f10e96935c0a3cafab31fb5b6f523.svg";
export { ForwardRef as ReactComponent };